import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { IMarca } from '../model/marca.model';

@Injectable()
export class MarcaService extends EntityService<IMarca> {
  constructor(protected configService: ConfigService) {
    super(
      {
        baseEntityEndPoint: 'marca',
        urlBackend: configService.backendURL
      }
    );
  }
}
